import { render, staticRenderFns } from "./decorPic.vue?vue&type=template&id=5aee9852&scoped=true"
import script from "./decorPic.vue?vue&type=script&lang=js"
export * from "./decorPic.vue?vue&type=script&lang=js"
import style0 from "./decorPic.vue?vue&type=style&index=0&id=5aee9852&prod&lang=scss&scoped=true"
import style1 from "./decorPic.vue?vue&type=style&index=1&id=5aee9852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aee9852",
  null
  
)

export default component.exports